export default "__VITE_ASSET__BfOUk$W3__"